import styled from 'styled-components';

export const PortfolioWrapper = styled.div`
  padding: 100px 0 56px 0;
`;
